/**
 * The Ask Bar's elevation — the floating composer's `--shadow-xl`
 * (sai-ui's `shadow-xl`).
 * Exported on its own because the floating recording bar wears the SAME
 * shadow (#14933): one constant, so the two cannot drift into two strings
 * that merely happen to agree.
 */
export const AI_ASK_SAI_ELEVATION_CLASS = '!shadow-[var(--shadow-xl)]'

/**
 * Shared SchoolAI composer treatment for every free-form AI ask control.
 *
 * These are the same material, radius, and inset-focus-shadow tokens used by
 * `@sai/ui`'s Composer. The shadow value is the package's own
 * `--shadow-focus-inset` (shadows.css, imported since #15994); referencing the
 * VARIABLE directly avoids recreating its blur, color, or light/dark values
 * locally. Not the `shadow-focus-inset` utility: src/tokens/sai-ui-names.css
 * keeps that one inert, so Cadence's focus ring stays the app-wide default.
 */
export const AI_ASK_CONTROL_CLASSES =
  '!rounded-4xl !border-0 transition-all ' +
  `!bg-material-thick ${AI_ASK_SAI_ELEVATION_CLASS} ` +
  'focus-within:!border-transparent ' +
  'focus-within:!shadow-[var(--shadow-focus-inset),var(--shadow-xl)]'
